module.exports = __webpack_public_path__ + "images/bannerEN-4ae67bff0e6937fc7af81002af209d2f.png";